dmx.Component('google', {

    // JavaScript Web Apps - https://developers.google.com/identity/protocols/OAuth2UserAgent
    // Mobile & Desktop Apps - https://developers.google.com/identity/protocols/OAuth2InstalledApp

    authEndpoint: 'https://accounts.google.com/o/oauth2/v2/auth',
    tokenEndpoint: 'https://www.googleapis.com/oauth2/v4/token',
    revokeEndpoint: 'https://accounts.google.com/o/oauth2/v2/revoke',

    initialData: {
        token: null,
        error: null,
    },

    attributes: {
        'client': {
            type: String,
            default: 'web' // web or app
        },

        'client-id': { // required
            type: String,
            default: null
        },

        'scope': { // required (https://developers.google.com/identity/protocols/googlescopes)
            type: String,
            default: null
        },

        'include-granted-scopes': {
            type: Boolean,
            default: false
        },

        'login-hint': { // prefill email address of user if known
            type: String,
            default: null
        },

        'prompt': {
            /*
                A space-delimited, case-sensitive list of prompts to present the user. If you don't specify this parameter, the user will be prompted only the first time your app requests access. Possible values are:
                none            - Do not display any authentication or consent screens. Must not be specified with other values.
                consent	        - Prompt the user for consent.
                select_account  - Prompt the user to select an account.
            */
            type: String,
            default: null
        },
    },

    methods: {
        authorize: function() {
            this.authorize();
        },

        refresh: function(refresh_token) {
            this.refresh(refresh_token);
        },

        revoke: function(token) {
            this.revoke(token);
        }
    },

    render: function() {
        // Check answer of google in hash fragment
        if (location.hash) {
            var params = new URLSearchParams(location.hash.slice(1));

            if (params.get('error')) {
                this.set('error', params.get('error'));
            } else if (params.get('access_token')) {
                if (this.validateState(params.get('state'))) {
                    this.set('token', {
                        access_token: params.get('access_token'),
                        token_type: params.get('token_type'),
                        expires_in: params.get('expires_in'),
                    });
                }
            } else if (params.get('code')) {
                if (this.validateState(params.get('state'))) {
                    this.getToken(params.get('code'));
                }
            }
        }
    },

    authorize: function() {
        var form = document.createElement('form');
        form.setAttribute('method', 'GET');
        form.setAttribute('action', this.authEndpoint);

        var params = {
            'client_id': this.props['client-id'],
            'redirect_uri': this.getRedirectURI(),
            'response_type': 'token',
            'scope': this.props['scope'],
            'state': this.generateState(),
        }

        if (this.props['include-granted-scopes']) {
            params['include_granted_scopes'] = 'true';
        }

        if (this.props['login-hint']) {
            params['login_hint'] = this.props['login-hint']
        }

        if (this.props['prompt']) {
            params['prompt'] = this.props['prompt']
        }

        if (this.props['client'] == 'app') {
            params['code_challenge_method'] = 'S256';
            params['code_challenge'] = this.generateCodeChallenge();
        }

        for (var p in params) {
            var input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', p);
            input.setAttribute('value', params[p]);
            form.appendChild(input);
        }

        document.body.appendChild(form);
        form.submit();
    },

    refresh: function(refresh_token) {
        this.post(this.tokenEndpoint, {
            'client_id': this.props['client-id'],
            'refresh_token': refresh_token,
            'grant_type': 'refresh_token'
        });
    },

    revoke: function(token) {
        var xhr = new XMLHttpRequest();

        xhr.addEventListener('load', (function() {
            this.set('token', null);
        }).bind(this));

        xhr.open('GET', this.revokeEndpoint + '?token=' + encodeURIComponent(token));

        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        xhr.send();
    },

    getRedirectURI: function() {
        return location.href.replace(/\?.*$/, '').replace(/#.*$/, '');
    },

    generateState: function() {
        var state = dmx.oauth2.generate_state();
        sessionStorage.setItem('google-state', state);
        return state;
    },

    validateState: function(state) {
        if (!state || state != sessionStorage.getItem('google-state')) {
            this.set('error', 'Invalid State');
            return false;
        }

        return true;
    },

    generateCodeChallenge: function() {
        var verifier = dmx.oauth2.generate_code_verifier();
        sessionStorage.setItem('google-verifier', verifier);
        return dmx.oauth2.generate_code_challenge(verifier);
    },

    getToken: function(code) {
        this.post(this.tokenEndpoint, {
            'code': code,
            'client_id': this.props['client-id'],
            'redirect_uri': this.getRedirectURI(),
            'grant_type': 'authorization_code',
            'code_verifier': sessionStorage.getItem('google-verifier'),
        });
    },

    post: function(uri, params) {
        var xhr = new XMLHttpRequest();

        xhr.addEventListener('load', (function() {
            this.set('token', JSON.parse(xhr.responseText));
        }).bind(this));

        xhr.open('POST', uri);

        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        xhr.send(Object.keys(params).map(function(key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&'));
    },

});
